import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import TopNav from "../TopNav";
import { BodyContainer } from "../StyledComponents";
import { getMembershipPlans } from "../../StateManagement/Reducers/MembershipState";
import {
  GetCardDetails,
  GetSingleInvoiceData,
} from "../../StateManagement/Reducers/BillingState";
import { MembershipInvoiceList_Api } from "../../MiddleWare/Apis/BillingApi";
import { Decrypt_Value } from "../../MiddleWare/EncryptDecrypt";
import MakePayment from "../StyledComponents/MakePayment";
import InvoicePopup from "../Billing/InvoiceList/InvoiceBalance/InvoicePopup";

import {
  PageWrapper,
  ContentCard,
  CardHeader,
  CardTitle,
  TableWrapper,
  TableHeader,
  HeaderText,
  TableBody,
  TableRow,
  CellText,
  InvoiceLink,
  StatusBadge,
  ActionWrapper,
  ActionButton,
  Dropdown,
  DropdownItem,
  EmptyText,
} from "./styles";
import {
  Modal,
  ModalContainer,
  ModalHeader,
  ModalBody,
  ModalTitle,
  Button,
} from "../StyledComponents";

import { BsXLg } from "react-icons/bs";

const MembershipPlan = () => {
  const dispatch = useDispatch();

  const membershipList = useSelector(
    (state) => state.Membership?.MembershipPlans || [],
  );
  const cardDetails = useSelector((state) => state.Billing?.CardDetail || []);
  const refresh = useSelector((state) => state.Billing?.Refresh);

  const [openDropdownId, setOpenDropdownId] = useState(null);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [selectedMembership, setSelectedMembership] = useState(null);

  const [showViewModal, setShowViewModal] = useState(false);
  const [selectedViewItem, setSelectedViewItem] = useState(null);

  const [showInvoiceModal, setShowInvoiceModal] = useState(false);
  const [selectedInvoiceData, setSelectedInvoiceData] = useState(null);

  const dropdownRef = useRef(null);

  useEffect(() => {
    dispatch(getMembershipPlans());
    dispatch(GetCardDetails());
  }, [dispatch]);

  useEffect(() => {
    if (refresh === 5) {
      dispatch(getMembershipPlans());
    }
  }, [refresh, dispatch]);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpenDropdownId(null);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  const handleActionClick = (id) => {
    if (openDropdownId === id) {
      setOpenDropdownId(null);
    } else {
      setOpenDropdownId(id);
    }
  };

  const handleView = (item) => {
    setOpenDropdownId(null);
    setSelectedViewItem(item);
    setShowViewModal(true);
  };

  const handleViewClose = () => {
    setShowViewModal(false);
    setSelectedViewItem(null);
  };

  const handlePay = (item) => {
    setOpenDropdownId(null);
    setSelectedMembership(item);
    setShowPaymentModal(true);
  };

  const handlePaymentModalClose = () => {
    setShowPaymentModal(false);
    setSelectedMembership(null);
  };

  const handleInvoiceClick = async (item) => {
    try {
      const res = await MembershipInvoiceList_Api();

      if (res.status === 200) {
        const decryptedData = Decrypt_Value(res.data, "vozoportal");
        const invoiceList = Array.isArray(decryptedData) ? decryptedData : [];

        const matchedInvoice = invoiceList.find(
          (row) => row.invoice_id === item.invoice,
        );

        if (matchedInvoice) {
          dispatch(GetSingleInvoiceData(matchedInvoice));
          setSelectedInvoiceData(matchedInvoice);
          setShowInvoiceModal(true);
        }
      }
    } catch (error) {
      console.log("Membership invoice popup open error:", error.message);
    }
  };

  const defaultCard = cardDetails.find((card) => String(card.def) === "1");

  return (
    <>
      <TopNav title="Membership Plan" />

      <BodyContainer
        paddingTop="2px"
        paddingRight="10px"
        paddingBottom="80px"
        paddingLeft="10px"
      >
        <PageWrapper>
          <ContentCard>
            <CardHeader>
              <CardTitle>Membership Plan List</CardTitle>
            </CardHeader>

            <TableWrapper>
              <TableHeader>
                <HeaderText>Plan Name</HeaderText>
                <HeaderText>Start Date</HeaderText>
                <HeaderText>End Date</HeaderText>
                <HeaderText>Fee</HeaderText>
                <HeaderText>Status</HeaderText>
                <HeaderText>Invoice</HeaderText>
                <HeaderText>Inv Status</HeaderText>
                <HeaderText>Action</HeaderText>
              </TableHeader>

              <TableBody>
                {membershipList.length > 0 ? (
                  membershipList.map((item) => (
                    <TableRow key={item.id}>
                      <CellText>{item.plan_name}</CellText>
                      <CellText>{item.start_date}</CellText>
                      <CellText>{item.end_date}</CellText>
                      <CellText>${item.fee}</CellText>

                      <StatusBadge
                        variant={
                          item.status === "Active" ? "active" : "inactive"
                        }
                      >
                        {item.status}
                      </StatusBadge>

                      <InvoiceLink onClick={() => handleInvoiceClick(item)}>
                        {item.invoice}
                      </InvoiceLink>

                      <StatusBadge
                        variant={
                          item.inv_status === "Unpaid" ? "inactive" : "active"
                        }
                      >
                        {item.inv_status}
                      </StatusBadge>

                      <ActionWrapper
                        ref={openDropdownId === item.id ? dropdownRef : null}
                      >
                        <ActionButton
                          type="button"
                          onClick={() => handleActionClick(item.id)}
                        >
                          &#8942;
                        </ActionButton>

                        {openDropdownId === item.id ? (
                          <Dropdown>
                            <DropdownItem onClick={() => handleView(item)}>
                              View
                            </DropdownItem>
                            {item.inv_status === "Unpaid" && (
                              <DropdownItem onClick={() => handlePay(item)}>
                                Pay
                              </DropdownItem>
                            )}
                          </Dropdown>
                        ) : null}
                      </ActionWrapper>
                    </TableRow>
                  ))
                ) : (
                  <EmptyText>No Membership Plans Found</EmptyText>
                )}
              </TableBody>
            </TableWrapper>
          </ContentCard>
        </PageWrapper>
      </BodyContainer>

      {showPaymentModal && selectedMembership && (
        <MakePayment
          show={showPaymentModal}
          ModalHide={handlePaymentModalClose}
          InvoiceList={[
            {
              invoice_id: selectedMembership.invoice,
              total_balance: selectedMembership.fee,
            },
          ]}
          CardDetails={cardDetails}
          patient_balance={selectedMembership.fee}
          makepayment="no"
          defaultcardcheck={defaultCard ? defaultCard.id : ""}
        />
      )}

      {showInvoiceModal && selectedInvoiceData && (
        <InvoicePopup
          show={showInvoiceModal}
          Data={selectedInvoiceData}
          cardDetails={cardDetails}
          defaultcardcheck={defaultCard ? defaultCard.id : ""}
          onHide={() => {
            setShowInvoiceModal(false);
            setSelectedInvoiceData(null);
          }}
        />
      )}

      {showViewModal && selectedViewItem && (
        <Modal width="100%" height="100%" show={showViewModal}>
          <ModalContainer justifyContent="center">
            <div
              style={{
                width: "100%",
                maxWidth: "560px",
                background: "#fff",
                borderRadius: "10px",
                overflow: "hidden",
                boxShadow: "0 10px 30px rgba(16,24,40,0.12)",
              }}
            >
              <ModalHeader
                padding="20px"
                borderLess
                justifyContent="space-between"
              >
                <ModalTitle fontSize="20px" fontWeight="600" color="#0A1629">
                  Membership Details
                </ModalTitle>

                <BsXLg
                  style={{ cursor: "pointer", fontSize: "14px" }}
                  onClick={handleViewClose}
                />
              </ModalHeader>

              <ModalBody>
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    gap: "16px",
                    padding: "0 20px 20px",
                  }}
                >
                  <div>
                    <div style={{ fontSize: "12px", color: "#667085" }}>
                      Plan Name
                    </div>
                    <div style={{ fontSize: "13px" }}>
                      {selectedViewItem.plan_name}
                    </div>
                  </div>

                  <div>
                    <div style={{ fontSize: "12px", color: "#667085" }}>
                      Start Date
                    </div>
                    <div style={{ fontSize: "13px" }}>
                      {selectedViewItem.start_date}
                    </div>
                  </div>

                  <div>
                    <div style={{ fontSize: "12px", color: "#667085" }}>
                      End Date
                    </div>
                    <div style={{ fontSize: "13px" }}>
                      {selectedViewItem.end_date}
                    </div>
                  </div>

                  <div>
                    <div style={{ fontSize: "12px", color: "#667085" }}>
                      Fee
                    </div>
                    <div style={{ fontSize: "13px" }}>
                      {selectedViewItem.fee}
                    </div>
                  </div>

                  <div>
                    <div style={{ fontSize: "12px", color: "#667085" }}>
                      Status
                    </div>
                    <div style={{ fontSize: "13px" }}>
                      {selectedViewItem.status}
                    </div>
                  </div>

                  <div>
                    <div style={{ fontSize: "12px", color: "#667085" }}>
                      Invoice
                    </div>
                    <div style={{ fontSize: "13px" }}>
                      {selectedViewItem.invoice}
                    </div>
                  </div>

                  <div>
                    <div style={{ fontSize: "12px", color: "#667085" }}>
                      Invoice Status
                    </div>
                    <div style={{ fontSize: "13px" }}>
                      {selectedViewItem.inv_status}
                    </div>
                  </div>
                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    padding: "0 20px 20px",
                  }}
                >
                  <Button
                    width="120px"
                    height="34px"
                    background="#2c7be5"
                    color="#fff"
                    borderRadius="4px"
                    onClick={handleViewClose}
                  >
                    Cancel
                  </Button>
                </div>
              </ModalBody>
            </div>
          </ModalContainer>
        </Modal>
      )}
    </>
  );
};

export default MembershipPlan;
